import React, { useState } from "react";
import axios from "axios";

export default function OrderTrackingPage() {
  const [tracking, setTracking] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  const trackOrder = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setData(null);

    try {
      const res = await axios.get(
        `https://api.motorwis.com/api/shipments/track/${tracking}`
      );
      setData({
        ...res.data,
        history: JSON.parse(res.data.history || "[]"),
      });
    } catch {
      setError("Tracking number not found.");
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (sec) =>
    new Date(sec * 1000).toLocaleString("en-US", {
      dateStyle: "medium",
      timeStyle: "short",
    });

  const statusColor = (status) => {
    const s = status.toLowerCase();
    if (s.includes("delivered")) return "#16a34a";
    if (s.includes("transit")) return "#2563eb";
    return "#7c3aed";
  };

  return (
    <>
      <style>{`
        body {
          background: #f6f7fb;
          font-size: 14px;
        }

        /* 🍎 BLUR HEADER */
        .hero {
          position: sticky;
          top: 0;
          z-index: 30;
          background: rgba(15,23,42,0.7);
          backdrop-filter: blur(18px);
          -webkit-backdrop-filter: blur(18px);
          padding: 18px 20px;
          text-align: center;
          color: white;
          border-bottom: 1px solid rgba(255,255,255,0.1);
        }

        .hero h1 {
          font-size: 20px;
          font-weight: 700;
          margin: 0;
        }

        .hero p {
          font-size: 12px;
          opacity: 0.85;
          margin: 2px 0 0;
        }

        .card {
          max-width: 980px;
          margin: 20px auto 60px;
          background: white;
          border-radius: 20px;
          padding: 22px;
          box-shadow: 0 20px 60px rgba(15,23,42,0.12);
        }

        .track-bar {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
        }

        .track-input {
          flex: 1;
          padding: 12px 14px;
          border-radius: 10px;
          border: 1px solid #e5e7eb;
        }

        .track-btn {
          padding: 12px 20px;
          border-radius: 10px;
          border: none;
          font-weight: 600;
          background: #2563eb;
          color: white;
        }

        .section {
          margin-top: 26px;
        }

        .section-title {
          font-weight: 700;
          font-size: 15px;
          margin-bottom: 12px;
        }

        /* 📌 STICKY SUMMARY */
        .summary-sticky {
          position: sticky;
          top: 64px;
          z-index: 20;
          background: linear-gradient(
            to bottom,
            rgba(246,247,251,0.95),
            rgba(246,247,251,0.75)
          );
          backdrop-filter: blur(10px);
          padding-top: 10px;
        }

        .summary-wrapper {
          overflow-x: auto;
          position: relative;
        }

        /* 👉 SCROLL INDICATOR */
        .scroll-hint {
          position: absolute;
          right: 10px;
          top: -18px;
          font-size: 11px;
          color: #64748b;
          animation: slideHint 1.8s infinite;
          white-space: nowrap;
        }

        @keyframes slideHint {
          0% { opacity: 0; transform: translateX(0); }
          50% { opacity: 1; transform: translateX(-6px); }
          100% { opacity: 0; transform: translateX(0); }
        }

        .summary {
          display: grid;
          grid-template-columns: repeat(4, minmax(180px, 1fr));
          gap: 12px;
          min-width: 720px;
        }

        .summary-card {
          background: #f8fafc;
          padding: 14px;
          border-radius: 14px;
          border: 1px solid #e5e7eb;
        }

        .label {
          font-size: 12px;
          color: #64748b;
        }

        .value {
          font-weight: 600;
        }

        .badge {
          padding: 4px 10px;
          border-radius: 999px;
          font-size: 12px;
          font-weight: 700;
          color: white;
        }

        .customer-wrapper {
          overflow-x: auto;
        }

        .customer-grid {
          display: grid;
          grid-template-columns: repeat(3, minmax(200px, 1fr));
          gap: 12px;
          min-width: 600px;
        }

        .box {
          background: white;
          border-radius: 14px;
          padding: 14px;
          border: 1px solid #e5e7eb;
        }

        /* TIMELINE */
        .timeline {
          border-left: 2px solid #e5e7eb;
          padding-left: 18px;
        }

        .event {
          position: relative;
          margin-bottom: 14px;
        }

        .event::before {
          content: "";
          position: absolute;
          left: -25px;
          top: 18px;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: #2563eb;
        }

        .event.latest::before {
          background: #16a34a;
          box-shadow: 0 0 0 5px rgba(22,163,74,0.15);
        }

        .event-card {
          background: #fff;
          border-radius: 12px;
          padding: 10px 12px;
          border: 1px solid #e5e7eb;
        }

        .event-row {
          display: grid;
          grid-template-columns: 1.3fr 1fr 2fr 1.2fr;
          gap: 10px;
          font-size: 12px;
        }

        .event-status {
          font-weight: 600;
          color: #2563eb;
        }

        .event-muted {
          color: #64748b;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      `}</style>

      {/* 🍎 BLUR HEADER */}
      <div className="hero">
        <h1>Track Shipment</h1>
        <p>Live delivery updates</p>
      </div>

      <div className="card">
        <form onSubmit={trackOrder}>
          <div className="track-bar">
            <input
              className="track-input"
              placeholder="Tracking number"
              value={tracking}
              onChange={(e) => setTracking(e.target.value)}
              required
            />
            <button className="track-btn" disabled={loading}>
              {loading ? "Tracking…" : "Track"}
            </button>
          </div>
        </form>

        {data && (
          <>
            {/* 📌 STICKY SUMMARY */}
            <div className="summary-sticky">
              <div className="summary-wrapper">
                <div className="scroll-hint">Swipe →</div>
                <div className="summary">
                  <div className="summary-card">
                    <div className="label">Tracking</div>
                    <div className="value">{data.trackingNumber}</div>
                  </div>

                  <div className="summary-card">
                    <div className="label">Status</div>
                    <span
                      className="badge"
                      style={{ background: statusColor(data.status) }}
                    >
                      {data.status}
                    </span>
                  </div>

                  <div className="summary-card">
                    <div className="label">Location</div>
                    <div className="value">{data.currentLocation}</div>
                  </div>

                  <div className="summary-card">
                    <div className="label">ETA</div>
                    <div className="value">
                      {new Date(data.estimatedDeliveryDate).toDateString()}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* CUSTOMER */}
            <div className="section">
              <div className="section-title">Customer</div>
              <div className="customer-wrapper">
                <div className="customer-grid">
                  <div className="box">{data.customerName}</div>
                  <div className="box">{data.customerPhone}</div>
                  <div className="box">{data.customerEmail}</div>
                </div>
              </div>
            </div>

            {/* SHIPPING */}
            <div className="section">
              <div className="section-title">Shipping Address</div>
              <div className="box">{data.shippingAddress}</div>
            </div>

            {/* TIMELINE */}
            <div className="section">
              <div className="section-title">Shipment Timeline</div>
              <div className="timeline">
                {data.history?.map((h, i) => (
                  <div
                    key={i}
                    className={`event ${
                      i === data.history.length - 1 ? "latest" : ""
                    }`}
                  >
                    <div className="event-card">
                      <div className="event-row">
                        <div className="event-status">{h.status}</div>

                        <div className="event-muted">
                          {h.location}
                        </div>

                        <div className="event-muted">
                          {h.notes || "—"}
                        </div>

                        <div className="event-muted">
                          {new Date(h.dateTime).toLocaleString()}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}
